import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_DEPLOY_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests withCredentials为true时，不允许设置Access-Control-Allow-Origin:* 需要指定origin
  timeout: 0, // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    // config.headers['Access-Control-Allow-Origin'] = '*'
    // config.headers['Origin'] = process.env.VUE_APP_BASE_API;
    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['X-Token'] = getToken()
      // config.headers["Access-Control-Allow-Origin"] = "*";
      // config.headers["Access-Control-Allow-Headers"]= "X-Requested-With,Content-Type";
      // config.headers["Access-Control-Allow-Methods"]="PUT,POST,GET,DELETE,OPTIONS";
      config.headers['Authorization'] = 'Bearer ' + getToken()
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data
    res.headers = response.headers
    // if the custom code is not 20000, it is judged as an error.
    if (!res.success) {
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        // to re-login
        MessageBox.confirm(
          'You have been logged out, you can cancel to stay on this page, or log in again',
          'Confirm logout',
          {
            confirmButtonText: 'Re-Login',
            cancelButtonText: 'Cancel',
            type: 'warning',
          }
        ).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
        return Promise.reject(new Error(res.message || 'Error'))
      } else {
        if (res.success != undefined) {
          Message({
            dangerouslyUseHTMLString: true,
            message: res.message || 'Error',
            type: 'error',
            duration: 5 * 1000,
          })
        }

        return res
      }
    } else {
      return res
    }
  },
  error => {
    const res = error['response']
    if (res == undefined) {
      Message({
        dangerouslyUseHTMLString: true,
        message: '無法連接伺服器，伺服器無回應。',
        type: 'error',
        duration: 5 * 1000,
      })
    }
    //   Object.keys(error).map(function(objectKey, index) {
    //     var value = error[objectKey];
    //     console.log(value);
    // });
    const statusCode = error.response.status
    switch (statusCode) {
      case 400:
        break
      case 401:
        store.dispatch('user/resetToken').then(() => {
          location.reload()
        })
        break
    }

    console.log('err：' + JSON.stringify(res)) // for debug
    let customErrorMsg = error.response.data.message ? error.response.data.message : ''

    if (statusCode != 456) {
      Message({
        dangerouslyUseHTMLString: true,
        message: `${error.response.statusText} - ${customErrorMsg}`,
        type: 'error',
        duration: 5 * 1000,
      })
    }

    return Promise.reject(res)
  }
)

export default service
